import { Link, useLocation } from 'react-router-dom';
import { Code2, FileText, User, Shield } from 'lucide-react';
import AuthButton from '@/auth/components/AuthButton';
import { useAuth } from '@/auth/hooks/useAuth';
import { useAdmin } from '@/admin/hooks/useAdmin';

export default function Header() {
  const { isAuthenticated } = useAuth();
  const { isAdmin } = useAdmin();
  const location = useLocation();

  const navItems = [
    { path: '/submit', label: 'Editor', icon: Code2 },
    { path: '/submissions', label: 'Mis Envíos', icon: FileText },
    { path: '/profile', label: 'Perfil', icon: User },
  ];

  const adminNavItem = isAdmin
    ? { path: '/admin', label: 'Admin', icon: Shield }
    : null;

  const filteredNavItems = isAuthenticated
    ? [...navItems, ...(adminNavItem ? [adminNavItem] : [])]
    : [];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to={isAuthenticated ? "/submit" : "/"} className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
              <Code2 className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold text-gray-900">
              Leet PI
            </span>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {filteredNavItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`
                    flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200
                    ${isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-600 hover:text-primary-600 hover:bg-gray-100'
                    }
                  `}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>

          {/* Auth Button */}
          <AuthButton />
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden border-t border-gray-200 py-4">
          <nav className="flex flex-wrap gap-2">
            {filteredNavItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`
                    flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200
                    ${isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-600 hover:text-primary-600 hover:bg-gray-100'
                    }
                  `}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
}
